import React, { Fragment } from "react";
import formElementsStyle from "./formElements.style";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../components/TextField";
import { Form, Field } from "react-final-form";
import createDecorator from "final-form-focus";
import FormStateToRedux from "Common/FormStateToRedux";
import store from "Store";

import T from "Translate";
import Validation from "Common/Validation/Validation";

import ContinueBtn from "../ContinueBtn/ContinueBtn";
import AlertDialog from "Common/AlertDialog/AlertDialog";
import Sponsor from "../Sponsor/Sponsor";

import PrivacyField from "../TermsPrivacyField/PrivacyField";
import TermsConditionsField from "../TermsPrivacyField/TermsConditionsField";
import { useTheme } from "@material-ui/styles";
import { unstable_useMediaQuery as useMediaQuery } from "@material-ui/core/useMediaQuery";
import useFormElements from "../hooks/useFormElements";
import { Captcha } from "../components/Captcha";
import PasswordField from "../components/PasswordField";
import Cookies from "universal-cookie";
import sendEvent, { EVENT } from "Services/googleAnalytics";
import PhoneInput from "../components/PhoneInput";

// Create Decorator
const focusOnErrors = createDecorator();

const { required, maxLength, validName, validEmail, emailNotTaken, composeValidators } = Validation;

const FormElements = props => {
    const {
        showPassword,
        setShowPassword,
        alertErrorMsg,
        open,
        setOpen,
        apiErroredOnCaptcha,
        setApiErroredOnCaptcha,
        onSubmit,
        getInitialValues
    } = useFormElements(props);
    const { classes } = props;

    const theme = useTheme();
    const sm = useMediaQuery(theme.breakpoints.up("sm"));
    const cookies = new Cookies();
    const initialValues = getInitialValues();

    const [formStartedEventSent, setFormStartedEventSent] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);

    const handleUpdate = (name, value) => event => {
        props.change(name, value);
    };

    const alertHandleClose = () => {
        setOpen(false);
    };

    return (
        <Fragment>
            <Form
                onSubmit={onSubmit}
                decorators={[focusOnErrors]}
                initialValues={initialValues}
                render={({ handleSubmit, validating, form, values, errors, touched, change }) => {
                    sessionStorage.setItem("sponsor", values.sponsor || "");

                    async function handleSubmitWithDelay(event) {
                        setSubmitting(true);
                        event.preventDefault();

                        const countryNoSponsorID = ["HK"];
                        if (countryNoSponsorID.includes(store.getState().locale.country) && !values.sponsor) {
                            values.sponsor = "105515785";
                            cookies.set("refEnrollerName", "Unicity HK", { path: "/" });
                        }

                        Object.keys(form.getState().errors).forEach(key => {
                            sendEvent(EVENT.FORM_JOIN_SUBMIT_VALIDATION_ERROR, { name: key });
                        });

                        if (validating) {
                            return;
                        }

                        sendEvent(EVENT.BUTTON_FORM_JOIN_SUBMIT);
                        await handleSubmit(event);
                        setSubmitting(false);
                    }

                    // Using > 1 because captcha field is always dirty
                    if (!formStartedEventSent && Object.keys(form.getState().dirtyFields).length > 1) {
                        setFormStartedEventSent(true);
                        sendEvent(EVENT.FORM_JOIN_STARTED);
                    }

                    return (
                        <form
                            onSubmit={handleSubmitWithDelay}
                            className={classes.root}
                            name="account"
                            data-testid="form_section"
                        >
                            <FormStateToRedux form="account" />
                            <Grid container direction="row" justify="center">
                                <Grid item xs={12}>
                                    <Sponsor validating={validating} form={form} />
                                </Grid>
                                <Grid container spacing={sm ? 16 : 0}>
                                    <Grid item xs={12} sm={6} data-testid="">
                                        <div className={classes.labelContent} data-testid="label_first_name">
                                            <T>first_name</T>
                                        </div>
                                        <Field
                                            name="firstName"
                                            type="text"
                                            component={TextField}
                                            placeholder="John"
                                            validate={composeValidators(required, maxLength(20), validName)}
                                            validateFields={[]}
                                            fullWidth
                                            dataTestId="first_name"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <div className={classes.labelContent} data-testid="label_last_name">
                                            <T>last_name</T>
                                        </div>
                                        <Field
                                            id="lastName"
                                            placeholder="Smith"
                                            name="lastName"
                                            type="text"
                                            component={TextField}
                                            validate={composeValidators(required, maxLength(20), validName)}
                                            validateFields={[]}
                                            fullWidth
                                            dataTestId="last_name"
                                        />
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <div className={classes.labelContent} data-testid="label_email">
                                        <T>email_address</T>
                                    </div>
                                    <Field
                                        id="emailAddress"
                                        name="emailAddress"
                                        placeholder="name@email.com"
                                        type="text"
                                        component={TextField}
                                        validate={composeValidators(required, validEmail, emailNotTaken)}
                                        validateFields={[]}
                                        fullWidth
                                        dataTestId="email"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <div className={classes.labelContent} data-testid="label_phone">
                                        <T>phone_number</T>
                                    </div>
                                    <PhoneInput
                                        value={values.phoneNumber}
                                        name="phoneNumber"
                                        change={change}
                                        submitting={submitting}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PasswordField
                                        showPassword={showPassword}
                                        setShowPassword={setShowPassword}
                                        value={values.password}
                                        submitting={submitting}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TermsConditionsField
                                        country={store.getState().locale.country}
                                        lang={store.getState().locale.language}
                                        value={values.termsCondition}
                                        onChange={() => {
                                            handleUpdate("termsCondition", values.termsCondition);
                                        }}
                                        validate={composeValidators(required)}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <PrivacyField
                                        country={store.getState().locale.country}
                                        values={values.privacypolicy}
                                        validate={composeValidators(required)}
                                        onChange={handleUpdate("privacypolicy", values.privacypolicy)}
                                    />
                                </Grid>

                                <Grid item xs={12} style={{ marginTop: "16px" }}>
                                    <Captcha
                                        onTokenRecieved={token => form.change("captchaToken", token)}
                                        formError={errors.captchaToken}
                                        touched={touched.captchaToken}
                                        apiErroredOnCaptcha={apiErroredOnCaptcha}
                                        setApiErroredOnCaptcha={setApiErroredOnCaptcha}
                                    />
                                    <Field
                                        name="captchaToken"
                                        id="captchaToken"
                                        type="hidden"
                                        render={() => <input type="hidden" />}
                                        validate={composeValidators(required)}
                                    />
                                </Grid>

                                <Grid item xs={12} style={{ marginTop: "25px" }}>
                                    <ContinueBtn
                                        handleSubmit={e => {
                                            setSubmitting(true);
                                            handleSubmitWithDelay(e);
                                        }}
                                        disabled={validating}
                                        submitting={submitting}
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    );
                }}
            />
            <AlertDialog
                alertOpen={open}
                alertHandleClose={alertHandleClose}
                alertTitle={"Error..."}
                alertMessage={alertErrorMsg}
            />
        </Fragment>
    );
};
export default withStyles(formElementsStyle)(FormElements);



// WEBPACK FOOTER //
// ./src/components/StartContainer/FormCountries/FormElements.js